module.exports = __webpack_public_path__ + "static/bg-welcome-4b51d230082912affcfc70fd5d20adb2.jpg";